import React, { useState, useEffect, useRef } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Card, Button, Row, Col } from "react-bootstrap";
import { X } from "react-feather";
import translate from "../../assets/Translate.png";
import "./previewfile.css";
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist";
import pdfWorker from "pdfjs-dist/build/pdf.worker.min.js";
import mammoth from "mammoth";

GlobalWorkerOptions.workerSrc = URL.createObjectURL(
  new Blob([pdfWorker], { type: "application/javascript" })
);

const PreviewFile = ({ originalFile, translatedFile, onClose }) => {
  const [fileName, setFileName] = useState("File name");
  const [downloadingFile, setDownloadingFile] = useState(null);
  const originalPreviewRef = useRef(null);
  const translatedPreviewRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [translatedFileURL, setTranslatedFileURL] = useState(null);

  useEffect(() => {
    if (originalFile && originalFile.file_name) {
      setFileName(originalFile.file_name);
    } else {
      setFileName("No file selected");
    }
    originalFile && loadPreviews("originalFile");
    translatedFile && loadPreviews("translatedFile");
  }, [originalFile, translatedFile]);

  const loadPreviews = async (file) => {
    switch (file) {
      case "originalFile":
        if (originalFile) {
          await handleFilePreview(
            originalFile,
            originalPreviewRef,
            "original-preview-container"
          );
        }
        break;
      case "translatedFile":
        if (translatedFile) {
          await handleFilePreview(
            translatedFile,
            translatedPreviewRef,
            "translated-preview-container"
          );
        }
        break;
      default:
        console.error("Invalid file type:", file);
        break;
    }
  };

  const handleFilePreview = async (file, previewRef, containerId) => {
    try {
      if (!file || !file.preview) {
        console.error("File is missing or invalid:", file);
        previewRef.current.innerHTML = "<p>No valid file provided.</p>";
        return;
      }
      if (file.type === "application/pdf") {
        await renderPdfPreview(file, previewRef);
      } else if (
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg"
      ) {
        renderImagePreview(file, previewRef);
      } else if (
        file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        renderDocxPreview(file, previewRef);
      } else {
        previewRef.current.innerHTML = `<img src=${translate} alt="Translation Placeholder" />`;
      }
    } catch (error) {
      console.error("Error processing file stream:", error);
      previewRef.current.innerHTML = "<p>Error loading file preview.</p>";
    }
  };

  const renderDocxPreview = async (file, previewRef) => {
    try {
      const response = await fetch(file.preview);
      const arrayBuffer = await response.arrayBuffer();

      const result = await mammoth.convertToHtml({ arrayBuffer });
      previewRef.current.innerHTML = result.value;
    } catch (error) {
      console.error("Error rendering DOCX file:", error);
      previewRef.current.innerHTML = "<p>Error rendering DOCX file.</p>";
    }
  };

  const renderPdfPreview = async (file, previewRef) => {
    const iframe = document.createElement("iframe");
    iframe.src = file.preview;
    iframe.width = "100%";
    iframe.height = "100%";
    previewRef.current.innerHTML = "";
    previewRef.current.appendChild(iframe);
  };

  const renderImagePreview = (file, previewRef) => {
    const img = document.createElement("img");
    img.src = file.preview;
    img.alt = file.file_name;
    // img.style.maxWidth = '100%';
    // img.style.maxHeight = '300px';
    previewRef.current.innerHTML = "";
    previewRef.current.appendChild(img);
  };

  const handleDownload = () => {
    if (translatedFile) {
      console.log("translatedFile headers:", translatedFile.headers);
      console.log("Available Headers:",Object.keys(translatedFile.headers || {}));

      // Extract filename from headers
      const contentDisposition =translatedFile.headers?.get("content-disposition");
      console.log("Content-Disposition Header:", contentDisposition);

      const filenameMatch = contentDisposition?.match(/filename="(.+)"/);
      const filename = filenameMatch ? filenameMatch[1] : "downloaded_file";

      // Create a download link
      const link = document.createElement("a");
      link.href = translatedFile.preview;
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.log("translatedFile is missing headers or undefined.");
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Card className="p-4">
      <Row className="mb-3 align-items-center">
        <Col>
          <h6>{fileName}</h6>
        </Col>
        <Col xs="auto">
          <button size="sm" className="close-button" onClick={handleClose}>
            <X size={18} />
          </button>
        </Col>
        <hr className="underline" />
      </Row>
      <Row>
        <Col md={6} className="doc-preview-col">
          <h6 className="text-center mb-3">Original Document</h6>
          <div className="border rounded p-3 doc-preview-box">
            <div
              ref={originalPreviewRef}
              style={{ height: "100%", width: "100%", overflow: "auto" }}
            >
              {originalFile ? (
                <></>
              ) : (
                <p className="text-muted">No original file selected.</p>
              )}
            </div>
          </div>
        </Col>
        <Col md={6} className="doc-preview-col">
          <h6 className="text-center mb-3">Translated Document</h6>
          <div className="border rounded p-3 doc-preview-box">
            <div
              ref={translatedPreviewRef}
              style={{ height: "100%", width: "100%", overflow: "auto" }}
            >
              {translatedFile ? (
                <></>
              ) : (
                <img
                  src={translate}
                  alt="Translation Placeholder"
                  style={{ maxWidth: "100%", maxHeight: "300px" }}
                />
              )}
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mt-4 justify-content-end">
        <Col xs="auto">
          <Button
            variant="primary"
            onClick={handleDownload}
            disabled={
              translatedFile?.status === "In Progress" ||
              translatedFile?.status === "Error Translating"
            }
          >
            {downloadingFile ? "Downloading..." : "Download"}
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default PreviewFile;
